import React from 'react'

const BackLinkIcon = () => {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.25 16H10.75C14.5 16 16 14.5 16 10.75V6.25C16 2.5 14.5 1 10.75 1H6.25C2.5 1 1 2.5 1 6.25V10.75C1 14.5 2.5 16 6.25 16Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.25078 11.0341H9.94077C11.2158 11.0341 12.2508 9.99906 12.2508 8.72406C12.2508 7.44906 11.2158 6.41406 9.94077 6.41406H4.86328" stroke="#111AE9" strokeWidth="1.5" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.9275 7.57733L4.75 6.39234L5.9275 5.21484" stroke="#111AE9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default BackLinkIcon